import {call, put, takeLatest} from 'redux-saga/effects';
import {SUCCESS_KEY} from 'constants/keys';
import {
  getEmployeesRequest,
  getEmployeesSuccess,
  getEmployeesFailure,
  getEmployeesRequestParams,
  getEmployeesSuccessResponse,
  addEmployeeRequest,
  addEmployeeSuccess,
  addEmployeeFailure,
  addEmployeeRequestPayload,
  addEmployeeSucessResponse,
  getEmployeeDetailsRequest,
  getEmployeeDetailsSuccess,
  getEmployeeDetailsFailure,
  getEmployeeDetailsParam,
  getEmployeeDetailsSuccessResponse,
  updateEmployeeDetailsRequest,
  updateEmployeeDetailsSuccess,
  updateEmployeeDetailsFailure,
  updateEmployeeDetailsParams,
  updateEmployeeDetailsSuccessResponse,
} from 'redux/slices/employeeSlice';
import {
  getEmployee,
  addEmployee as addEmployeeAPI,
  getEmployeeDetails as getEmployeeDetailsAPI,
  updateEmployee as updateEmployeeAPI,
} from 'services/api';

/**
 * type for get employee request
 */
type GetEmployeesRequestAction = {
  type: typeof getEmployeesRequest.type;
  payload: getEmployeesRequestParams;
};

type getEmployeesResponse = {
  status: string;
} & getEmployeesSuccessResponse;

/**
 * type for add employee request
 */
type AddEmployeeRequestAction = {
  type: typeof addEmployeeRequest.type;
  payload: addEmployeeRequestPayload;
};

type AddEmployeeResponse = {
  status: string;
} & addEmployeeSucessResponse;

/**
 * type for employee details
 */
type GetEmployeeDetailsAction = {
  type: typeof getEmployeeDetailsRequest.type;
  payload: getEmployeeDetailsParam;
};

type GetEmployeeDetailsResponse = {
  status: string;
} & getEmployeeDetailsSuccessResponse;

/**
 * type for update employee details
 */
type UpdateEmployeeDetailsAction = {
  type: typeof updateEmployeeDetailsRequest.type;
  payload: updateEmployeeDetailsParams;
};

type UpdateEmployeeDetailsResponse = {
  status: string;
} & updateEmployeeDetailsSuccessResponse;

//saga functions

function* employees(action: GetEmployeesRequestAction): Generator {
  try {
    const response: getEmployeesResponse = yield call(
      getEmployee,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(getEmployeesSuccess(response));
    } else {
      yield put(getEmployeesFailure(response.status_code));
    }
  } catch (error) {
    yield put(getEmployeesFailure('E-10001'));
  }
}

/**
 * saga function for add projects
 */
function* addEmployee(action: AddEmployeeRequestAction): Generator {
  try {
    const response: AddEmployeeResponse = yield call(
      addEmployeeAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(addEmployeeSuccess(response));
    } else {
      yield put(addEmployeeFailure(response.status_code));
    }
  } catch (error) {
    yield put(addEmployeeFailure('E-10001'));
  }
}

/**
 * saga function for get employee details
 */

function* getEmployeeDetails(action: GetEmployeeDetailsAction): Generator {
  try {
    const response: GetEmployeeDetailsResponse = yield call(
      getEmployeeDetailsAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(getEmployeeDetailsSuccess(response));
    } else {
      yield put(getEmployeeDetailsFailure(response.status_code));
    }
  } catch (error) {
    yield put(getEmployeeDetailsFailure('E-10001'));
  }
}

/**
 * saga function to update employee details
 */

function* updateEmployee(action: UpdateEmployeeDetailsAction): Generator {
  try {
    const response: UpdateEmployeeDetailsResponse = yield call(
      updateEmployeeAPI,
      action.payload,
    );
    if (response.status === SUCCESS_KEY) {
      yield put(updateEmployeeDetailsSuccess(response));
    } else {
      yield put(updateEmployeeDetailsFailure(response.status_code));
    }
  } catch (error) {
    yield put(updateEmployeeDetailsFailure('E-10001'));
  }
}

//saga listener
export function* employeeSaga() {
  yield takeLatest(getEmployeesRequest.type, employees);
  yield takeLatest(addEmployeeRequest.type, addEmployee);
  yield takeLatest(getEmployeeDetailsRequest.type, getEmployeeDetails);
  yield takeLatest(updateEmployeeDetailsRequest.type, updateEmployee);
}
